import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

// Account-level lb/kg preference (stored values are always lb).
export const useWeightUnit = () => {
  const { api, user, refreshUser } = useAuth();
  const unit = user?.weight_unit === 'kg' ? 'kg' : 'lb';
  const setUnit = async (next) => {
    if (next === unit) return;
    try {
      await api().put('/auth/profile', { weight_unit: next });
      await refreshUser?.();
    } catch {
      toast.error('Could not save unit preference');
    }
  };
  return { unit, setUnit };
};

export default useWeightUnit;
